import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { Icon } from "../Icon/Icon";
export const StatusIcon = ({ status = "info", enableFocus = false, statusIconSize = "m", className, ...rest }) => {
    /** Maps the status prop to the appropriate icon name */
    const getIconName = new Map([
        ["info", "Info"],
        ["neutral", "Info"],
        ["success", "Check"],
        ["warning", "Alert"],
        ["error", "Close"],
        ["danger", "Close"],
    ]);
    const getIcon = () => {
        return (_jsx(Icon, { "aria-label": status, name: getIconName.get(status), size: statusIconSize, backgroundShape: "circle", enableFocus: enableFocus }));
    };
    return (_jsx("div", { className: classNames("eds-status-icon", `eds-status-icon--${statusIconSize}`, `eds-status-icon--${status}`, className), ...rest, children: getIcon() }));
};
